import { render, staticRenderFns } from "./TabelaConsultarUnimed.vue?vue&type=template&id=caf79f88"
import script from "./TabelaConsultarUnimed.vue?vue&type=script&lang=js"
export * from "./TabelaConsultarUnimed.vue?vue&type=script&lang=js"
import style0 from "./TabelaConsultarUnimed.vue?vue&type=style&index=0&id=caf79f88&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports